import { combineReducers } from 'redux';
import { all, fork } from 'redux-saga/effects';
import { connectRouter, RouterState } from 'connected-react-router';
import { History } from 'history';
import { ErrorState } from './error/types';
import { errorReducer } from './error/reducers';
import { AdminSearchState } from './admin_search/types';
import { adminSearchReducer } from './admin_search/reducers';
import { NotificationState } from './notification/types';
import { notificationReducer } from './notification/reducers';
import { currentUserReducer, CurrentUserState } from './current_user'
import notificationSaga from './notification/sagas';

// storeの型を定義
export interface ApplicationState {
  error: ErrorState;
  router: RouterState;
  adminSearch: AdminSearchState;
  notification: NotificationState;
  currentUser: CurrentUserState;
}

// 複数のreducerをまとめる
export const createRootReducer = (history: History) =>
  combineReducers({
    error: errorReducer,
    router: connectRouter(history),
    adminSearch: adminSearchReducer,
    notification: notificationReducer,
    currentUser: currentUserReducer
  });

// 複数のsagaをまとめる
export function* rootSaga() {
  yield all([fork(notificationSaga)]);
}
